import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=6d932fdb"
import script from "./DownloadReport.vue?vue&type=script&lang=ts"
export * from "./DownloadReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports